import { App } from './App';
import React from 'react';
import ReactDOM from 'react-dom';
import { BackInStockConfiguration, } from './helpers/BackInStockConfiguration';
export const render = (rootEl) => {
    const { apiUrl = '', tenant = '', config } = rootEl.dataset;
    if (config) {
        try {
            const backInStockConfig = JSON.parse(decodeURIComponent(config));
            BackInStockConfiguration.init({
                apiUrl,
                tenant,
                config: backInStockConfig,
            });
            // eslint-disable-next-line @typescript-eslint/no-implicit-any-catch
        }
        catch (error) {
            console.log(error);
        }
    }
    ReactDOM.render(React.createElement(App, null), rootEl);
};
